import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HashRouter} from 'react-router-dom'

// ── Global crash visibility ──────────────────────────────────────────────
// Surface ANY uncaught error / unhandled promise rejection as a fixed red
// banner, so a blank/black screen is never silent (catches things a React
// error boundary can't, e.g. async errors). Temporary diagnostic aid.
function __showGlobalError(label, err) {
  try {
    let box = document.getElementById('__global_error_box');
    if (!box) {
      box = document.createElement('div');
      box.id = '__global_error_box';
      box.style.cssText =
        'position:fixed;z-index:2147483647;left:0;right:0;bottom:0;max-height:60vh;overflow:auto;' +
        'background:#1a0000;color:#ff8a8a;font:12px/1.5 monospace;padding:12px;' +
        'border-top:3px solid #ff5252;white-space:pre-wrap';
      (document.body || document.documentElement).appendChild(box);
    }
    const msg = (err && (err.stack || err.message)) || String(err);
    box.textContent = `[${label}] ${msg}\n\n` + (box.textContent || '');
  } catch (_) { /* never let the reporter itself throw */ }
}
window.addEventListener('error', (e) => __showGlobalError('error', e.error || e.message));
window.addEventListener('unhandledrejection', (e) => __showGlobalError('promise', e.reason));




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <App />
</HashRouter>
  );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
